import type { ElementType } from "react";
import {
  ArrowRightLeft,
  Building2,
  Network,
  ClipboardList,
  Globe,
  HeartHandshake,
  KeyRound,
  LayoutDashboard,
  ListChecks,
  Mail,
  Plug,
  Settings,
  ShieldCheck,
  Stethoscope,
  Upload,
  User,
  Users,
} from "lucide-react";
import type { ShellNavSection } from "../shell/types";
import { PRP_ONLY_HIDDEN_SETTINGS } from "@/lib/prp-only";

export const SETTINGS_NAV: ShellNavSection[] = [
  {
    label: "Overview",
    items: [
      { label: "Settings home", icon: LayoutDashboard, href: "/settings" },
    ],
  },
  {
    label: "Organization",
    items: [
      { label: "Practice info", icon: Building2, href: "/settings/organization" },
      { label: "Locations", icon: Globe, href: "/settings/locations" },
      { label: "Departments", icon: Network, href: "/settings/departments" },
      { label: "Visit reasons", icon: Stethoscope, href: "/settings/visit-reasons" },
      { label: "Price list", icon: ListChecks, href: "/billing/price-list" },
    ],
  },
  {
    label: "Team and access",
    items: [
      { label: "Users", icon: Users, href: "/settings/users" },
      { label: "Providers", icon: User, href: "/settings/providers" },
      { label: "Roles and permissions", icon: KeyRound, href: "/settings/roles" },
    ],
  },
  {
    label: "Security",
    items: [
      { label: "Security and privacy", icon: ShieldCheck, href: "/settings/security" },
      { label: "Audit log", icon: ClipboardList, href: "/settings/audit" },
    ],
  },
  {
    label: "System",
    items: [
      { label: "Message outbox", icon: Mail, href: "/settings/email-outbox" },
      { label: "Record exchange", icon: ArrowRightLeft, href: "/settings/record-exchange" },
      { label: "Import patients", icon: Upload, href: "/settings/import-patients" },
      { label: "Integrations", icon: Plug, href: "/settings/integrations" },
    ],
  },
];

export const PRP_SETTINGS_SECTION: ShellNavSection = {
  label: "Programs",
  items: [{ label: "PRP program", icon: HeartHandshake, href: "/settings/prp" }],
};

/**
 * Settings menu for the clinic's plan: a PRP Programs plan drops full-EHR
 * pages; any clinic running a PRP gets the PRP Program page.
 */
export function settingsNavFor(opts: { prpOnly: boolean; prp: boolean }): ShellNavSection[] {
  const sections = opts.prpOnly
    ? SETTINGS_NAV.map((section) => ({
        ...section,
        items: section.items.filter((item) => !PRP_ONLY_HIDDEN_SETTINGS.has(item.href)),
      })).filter((section) => section.items.length > 0)
    : SETTINGS_NAV;
  if (!opts.prp && !opts.prpOnly) return sections;
  // After Organization, so program setup sits next to practice setup.
  return [sections[0], sections[1], PRP_SETTINGS_SECTION, ...sections.slice(2)].filter(
    (s): s is ShellNavSection => !!s,
  );
}

export const SETTINGS_SIDEBAR_HEADER = {
  title: "Settings",
  subtitle: "Configuration",
  icon: Settings as ElementType,
};
